import(/* webpackMode: "eager" */ "/app/apps/paz-corporate/app/[locale]/(corporate)/error.tsx");
